if (typeof window !== 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
      // Look for the gift card section by a reliable identifier
      const giftCardSection = Array.from(document.querySelectorAll('[id^="shopify-section-"]')).find(section => 
        section.innerHTML.includes('factor4_gift_cards_plus_product_customization')
      );
      
      if (giftCardSection) {
        const formBlock = document.querySelector('[id*="factor4_gift_cards_plus_product_customization"]');
        const addToCartForm = document.getElementById('add-to-cart');
        
        if (formBlock && addToCartForm) {
          const addToCartButton = addToCartForm.querySelector('.btn.btn--std');
          if (addToCartButton) {
            addToCartButton.before(formBlock);
          }
        }
      }
    });
  }